module.exports = "/static/assets/70446004563ddaa571a16dd126e17256.png";